import template from './mx-advanced-search-query.component.html';

export class MxAdvancedSearchQueryController {
	static $inject = ['mx.SolutionBuilderAgent.SearchQueryService', 'mx.shell.SearchProviderService', 'mx.shell.EventService', 'mx.internationalization'];

	query;
	context;
	uiToken;
	searchService; /*private*/
	searchQueryService; /*private*/
	eventService; /*private*/
	i18n; /*private*/
	editText = null;
	editIcon = null;

	constructor(searchQueryService, searchService, eventService, i18n) {
		this.searchService = searchService;
		this.searchQueryService = searchQueryService;
		this.eventService = eventService;
		this.i18n = i18n;
	}

	async edit() {
		await this.searchQueryService.openFilterDialog(this.query, this.context);
	}

	$onInit() {
		this.editText = this.i18n.get('solutionBuilderAgent.components.mx-advanced-search-query.' + (this.query.canEdit ? 'edit' : 'view'));
		this.editIcon = this.query.canEdit ? 'edit' : 'info';
	}

	run() {
		const queryId = this.query.id;

		if (queryId) {
			const currentSearch = this.searchService.currentSearch();
			currentSearch.filters = [queryId];
			const currentBaseFilter = this.searchService.getBaseQueryId(this.context?.parameters);
			if (currentBaseFilter) {
				currentSearch.filters.push(currentBaseFilter);
			}

			currentSearch.context = this.context;
			currentSearch.uiToken = this.uiToken;
			this.searchService.runSearch();
			this.eventService.dispatchEvent(mx.SolutionBuilderAgent.Events.RunSearchQuery, queryId);
		}
	}

	attach(query) {
		query.__attached = true;
	}
}

angular.module('mx.SolutionBuilderAgent').component('mxAdvancedSearchQuery', {
	bindings: {
		query: '=',
		context: '=',
		uiToken: '@',
	},
	controller: MxAdvancedSearchQueryController,
	controllerAs: 'vm',
	template: template,
});
